import React, { useState } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '@fluentui/react';
import { Link } from 'react-router-dom';
import userStore from '../../../stores/user.store';
import { DangerButtonStyled } from '../../../style/components/button.styled';
import { addToast } from '../../components/toasts/Toast';

const Styles = styled.div`

`;

const WrapperStyles = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: baseline;
  grid-gap: 20px;

  .kzpd {
    width: 300px;
    background-color: #122330;
    border-radius: 2px;
    text-align: center;
    padding: 9px 0;
  }
`;

const NoMoneyNoHoneyStyles = styled.div`

`;

const ApiKeyStyles = styled.div`

`;

const GenerateApiKeyStyles = styled.div`

`;

const ApiKey = ({ sub, apiKey }) => {
    const [isSending, setIsSending] = useState(false);
    let key = apiKey ? apiKey : 'No API key';
    let canGenerateApiKey = false;
    if (sub && sub.status === 'ACTIVE') {
        if (sub.subscriptionNumber > 3 && sub.subscriptionNumber < 12) {
            canGenerateApiKey = true;
        }
    }

    const generateApiKey = async () => {
        if (isSending) return;
        setIsSending(true);
        try {
            await userStore.generateApiKey();
        } catch (error) {
            addToast(error.message || 'Failed to generate API key', 'error');
        } finally {
            setIsSending(false);
        }
    };

    const deleteApiKey = async () => {
        if (isSending) return;
        setIsSending(true);
        try {
            await userStore.deleteApiKey();
        } catch (error) {
            addToast(error.message || 'Failed to delete API key', 'error');
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Styles>
            <h3>API key</h3>

            { !canGenerateApiKey && (
                <NoMoneyNoHoneyStyles>
                    In order to get apiKey you need to be supporter with API
                    access. To support - <Link to={ '/donate' }>Donate</Link>
                </NoMoneyNoHoneyStyles>
            ) }

            { canGenerateApiKey && (
                <WrapperStyles>
                    <div className="kzpd">
                        { key }
                    </div>
                    { apiKey && (
                        <ApiKeyStyles>
                            <DangerButtonStyled
                                disabled={ isSending }
                                onClick={ deleteApiKey }
                            >
                                Delete
                            </DangerButtonStyled>
                        </ApiKeyStyles>
                    ) }

                    { !apiKey && (
                        <GenerateApiKeyStyles>
                            <PrimaryButton
                                text={ 'Generate' }
                                disabled={ isSending }
                                onClick={ generateApiKey }
                            />
                        </GenerateApiKeyStyles>
                    ) }
                </WrapperStyles>
            ) }
        </Styles>
    );
};

export default ApiKey;
